export function getUniqueValues(values: number[]) {
    return [...values.reduce((map, val) => map.set(val, (map.get(val) || 0) + 1), new Map())].map(([value, count]) => ({
        value,
        count,
    }));
}
